import axios from "@/plugins/axiosInstance";
import { googleIntegration } from "@/networking/urlManager";
import { responseHandlerService } from "@/plugins/responseHandlerService";

/**
 * Mülk bağlantısını kontrol et
 * @param {string} assetId - Asset ID
 * @returns {Promise<Object>} - Mülk bağlantı durumu
 */
export async function checkPropertyLinked(assetId) {
  try {
    // API isteği gönder
    const response = await axios.get(googleIntegration.checkPropertyLinked, {
      params: {
        assetId: assetId,
      },
    });

    // Başarılı yanıt durumu
    if (response.data && response.data.data) {
      return {
        isLinked: response.data.data.status,
        error: null,
      };
    } else {
      return {
        isLinked: false,
        error: null,
      };
    }
  } catch (error) {
    // Hata durumunda sessizce başarısız sonuç dön, hata mesajı gösterme
    responseHandlerService.handleError(
      error, 
      null, 
      'silent' // Kullanıcıya bildirim gösterme
    );
    return {
      isLinked: false,
      error: error,
    };
  }
}